export var userCrosswalk3395138 = {
    eolsId: 3395138,
    externalUserId: 34508205,
    userName: 'skillian26',
    type: 'evolve',
    userData: null,
    eolsUserIdsByUserNameAndType: [] // [2300495, 2270990, 3395138] for future reference
};
